<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
};
</script>

<style>
body {
  margin: 0;
}
.el-header {
  padding: 0 !important;
  /* height: 43px !important; */
}
#app {
  background-color: #f5f5f5;
}
</style>
